export const messages = {
    nameEmpty: "Name cannot be empty.",
    emailEmpty: "Email Address cannot be empty.",
    emailNotValid: "Email Address is not valid, please enter a proper email address.",
    locationEmpty: "Location cannot be empty.",
    interests: "Select 3 area of interest.",
    profileSaved: "Profile details saved.",
    profilePic: "Profile picture saved.",
    addToFavorites:"Successfully added to favorites.",
    removeFromFavorites:"Successfully removed from favorites"
};


// WEBPACK FOOTER //
// ./src/constants/messages.js